// extracted by mini-css-extract-plugin
export default {"dateSelector":"styles_dateSelector__zNZwb","rtl":"styles_rtl__PCnmq"};